import styled from "styled-components";

export const ResultsContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  border-radius: 8px;
  & .pagination-footer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 20px 10px;
  }
`;
export const FoundWorks = styled.div`
  width: 100%;
  height: 100%;
  margin: 10px auto;
  & .user h3 {
    font-weight: 800;
    margin-bottom: 0px;
    padding: 20px 0px;
  }
`;

export const FilterContainer = styled.div`
  /* border-radius: 10px; */
  /* padding: 20px; */
  /* background: #fff; */
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const SearchInput = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  & .ant-input-affix-wrapper input.ant-input {
    min-width: 150px !important;
    width: 100%;
  }
`;
